import { render, staticRenderFns } from "./ProjectIndex.vue?vue&type=template&id=368bf9e6"
import script from "./ProjectIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectIndex.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports